import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { DashboardData } from "src/app/shared/models/dashboard.model";
import { AuthService } from "src/app/shared/services/auth.service";
import { Router } from "@angular/router";
import { RouteEnum } from "src/app/shared/models/routes.model";
import { Store } from "@ngrx/store";
import {
  UI__ROUTE_NAVIGATION,
  UI__SIDEBAR_ROUTE_NAVIGATION,
} from "src/app/shared/ngrx/ngrx-actions";
import { dashboardData } from "src/app/shared/ngrx/ngrx-selectors";
import { TranslateModule } from "@ngx-translate/core";
import { CommonModule } from "@angular/common";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "dash-chat-summary",
  templateUrl: "./dash-chat-summary.component.html",
  styleUrls: ["./dash-chat-summary.component.sass"],
  imports: [TranslateModule, CommonModule],
  standalone: true,
})
export class DashChatSummaryComponent implements OnInit {
  displayDetailedUnreadMessages: boolean;
  displayDueDateUpdates: boolean;
  displayMsgFromPlantAgent: boolean;
  routeEnum: RouteEnum = new RouteEnum();

  get data(): DashboardData {
    return this.store.selectSignal(dashboardData)();
  }

  constructor(
    private readonly store: Store,
    private authService: AuthService,
    private router: Router
  ) {
    this.displayDetailedUnreadMessages =
      this.authService.currentUser.org == "LAB";
    this.displayMsgFromPlantAgent =
      this.authService.currentUser.org == "LAB" &&
      this.authService.currentUser.roleCode != "PLANT_AGENT";
    this.displayDueDateUpdates = this.authService.currentUser.org == "CLINIC";
  }

  ngOnInit(): void {}

  filterOrdersByChatCode(code: string) {
    this._dispatchInboxNavigation();

    this.router.navigate([this.routeEnum.URL_INBOX], {
      queryParams: { chatCode: code, reuse: "false" },
    });
  }

  _dispatchInboxNavigation() {
    this.store.dispatch(
      UI__ROUTE_NAVIGATION({
        data: { link: this.routeEnum.URL_INBOX },
      })
    );

    this.store.dispatch(
      UI__SIDEBAR_ROUTE_NAVIGATION({
        data: { tabId: "inbox" },
      })
    );
  }
}
